export default __webpack_public_path__ + "static/media/DinosaursHerbivores_01.e793f388.png";